import axios from 'axios';
import { Dialog } from 'quasar';
import { i18n } from 'src/boot/i18n';

const OrderService = {
  post(order) {
    return axios.post('order', order).catch((error) => {
      if (error.response.data.code) {
        Dialog.create({
          title: i18n.t(`api.error.${error.response.data.code}.title`),
          message: i18n.t(`api.error.${error.response.data.code}.message`, {
            error: error.response.data.error,
          }),
          ok: i18n.t('api.error.dialog.ok'),
        });
      }
    });
  },
};

export default OrderService;
